import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as l, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconHd",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function v(e, t, i, h, u, a) {
  return d(), l("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--hd"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Hd",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1 9.5A1.5 1.5 0 0 0 2.5 11h7c.826 0 1.5-.674 1.5-1.5v-7c0-.826-.674-1.5-1.5-1.5h-7A1.5 1.5 0 0 0 1 2.5v7Zm1.5.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h7c.274 0 .5.226.5.5v7c0 .274-.226.5-.5.5h-7Zm.75-2a.5.5 0 0 0 .5-.5v-1h1v1a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0v1h-1v-1a.5.5 0 0 0-1 0v3a.5.5 0 0 0 .5.5Zm3-.5a.5.5 0 0 0 .5.5h.5a2 2 0 1 0 0-4h-.5a.5.5 0 0 0-.5.5v3Zm1-.5V5a1 1 0 0 1 0 2Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const b = /* @__PURE__ */ s(c, [["render", v]]);
export {
  b as default
};
//# sourceMappingURL=hd.js.map
